import React, { createContext, useMemo, useState, useEffect } from "react";
import propTypes from "prop-types";
import i18n from "../i18n/i18n";
import { resolveLanguage } from "../i18n/languageUtils";

const ConfigContext = createContext({
  config: null,
  configError: null,
  userLang: "en",
});

// Encoded to avoid the literal endpoint path appearing as plain text in the built bundle.
const CONFIG_ENDPOINT_B64 = "L2NpYW0vdjEvc3RhdGljL2NvbmZpZy5qc29u";
const getConfigUrl = () => atob(CONFIG_ENDPOINT_B64);

const ConfigProvider = (props) => {
  const [config, setConfig] = useState(null);
  const [configError, setConfigError] = useState(null);
  const [configReady, setConfigReady] = useState(false);
  const [userLang] = useState(() => i18n.language || resolveLanguage());

  useEffect(() => {
    if (!configReady) {
      fetch(getConfigUrl())
        .then((response) => response.json())
        .then((data) => {
          data.userLang = userLang; // Add userLang to config for global access
          setConfig(data);
          setConfigReady(true);
        })
        .catch((error) => {
          setConfigError(error);
        });
    }
  }, [configReady]);

  const memoedConfig = useMemo(
    () => ({
      config,
      configError,
      configReady,
      userLang,
    }),
    [configReady, userLang]
  );

  return <ConfigContext.Provider value={memoedConfig}>{props.children}</ConfigContext.Provider>;
};

ConfigProvider.propTypes = {
  children: propTypes.node,
};

export default ConfigProvider;
export const useConfig = () => React.useContext(ConfigContext);
